module.exports = __webpack_public_path__ + "static/primaryendpointbytriglyceride_chart_mobile-09146dde157ab8964e8e5bec690b79d7.png";